import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { DBO_REQ } from '@op/utils/format';
import { getHashtagTrendTimeline } from '@opm/services';
import { useEffect, useState } from 'react';

export function useHashtagTrend({ filter }: { filter: any }) {
  const [data, setData] = useState<any>({});
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
  });

  function request() {
    wrapperCancelRequest(getHashtagTrendTimeline, filter)
      .then(data => {
        const { timeline, timeline_of_start_time, timeline_of_end_time } =
          data || {};
        const chartData = DBO_REQ.moreKeys({
          timeline,
          timeline_of_start_time,
          timeline_of_end_time,
          fixedKeyList: ['tweets_views', 'tweets_posts'],
          needTable: true,
          filter,
        });
        setData({ ...chartData, ...data });
      })
      .catch(() => {});
  }

  useEffect(() => {
    if (filter) {
      request();
    }
  }, [filter]);

  return {
    data,
    loading,
  };
}
